// extracted by mini-css-extract-plugin
export default {"labeled-input-conatiner":"styles_labeled-input-conatiner__W2Jn3","labeled-input-label":"styles_labeled-input-label__0P4VA","labeled-input-input":"styles_labeled-input-input__Kyn60"};